import { GreenCarIcon, GreenCustomerIcon, GreenBrandIcon } from 'src/icons'

const SocialProofData = [
  {
    title: '700.000 Clienti',
    description: 'soddisfatti',
    icon: <GreenCustomerIcon />,
  },
  {
    title: '35.000 Auto',
    description: 'acquistate',
    icon: <GreenCarIcon />,
  },
  {
    title: '27 Brand',
    description: 'con cui collaboriamo',
    icon: <GreenBrandIcon />,
  },
]

export default SocialProofData
